import axios from "@/request";
import qs from "qs";

export default {
  async categories(params: any) {
    return axios.get("bom/material/categories", { params });
  },
  async materialList(params: any) {
    return axios.get("bom/material/list", { params });
  },
  async addMaterial(params: any) {
    return axios.post("bom/material/add", qs.stringify(params));
  },
  async editMaterial(params: any) {
    return axios.post("bom/material/edit", qs.stringify(params));
  },
  async detailMaterial(params: any) {
    return axios.get("bom/material/detail", { params });
  },
  async deleteMaterial(params: any) {
    return axios.post("bom/material/delete", qs.stringify(params));
  },
  async materialCategoryList(params: any) {
    return axios.get("bom/material-category/list", { params });
  },
  async addMaterialCategory(params: any) {
    return axios.post("bom/material-category/add", qs.stringify(params));
  },
  async editMaterialCategory(params: any) {
    return axios.post("bom/material-category/edit", qs.stringify(params));
  },
  async detailMaterialCategory(params: any) {
    return axios.get("bom/material-category/detail", { params });
  },
  async deleteMaterialCategory(params: any) {
    return axios.post("bom/material-category/delete", qs.stringify(params));
  }
};
